export default __webpack_public_path__ + "static/media/camparator-402x100.cbe84cbc.png";